export const subprocessorsEndpoints = {
  listOrganisationSubprocessors: { method: 'post', path: '/' },
  createOrganisationSubprocessor: { method: 'post', path: '/create' },
  updateOrganisationSubprocessor: { method: 'post', path: '/{organisationSubprocessorId}/update' },
  deleteOrganisationSubprocessor: { method: 'post', path: '/{organisationSubprocessorId}/delete' },
  listOrgSuppliersBySubprocessor: { method: 'post', path: '/{organisationSubprocessorId}/suppliers' },
  createOrgSupplierSubprocessorLink: { method: 'post', path: '/{organisationSubprocessorId}/suppliers/create' },
  updateOrgSupplierSubprocessorLink: {
    method: 'post',
    path: '/{organisationSubprocessorId}/suppliers/{supplierSubprocessorId}/update',
  },
  deleteOrgSupplierSubprocessorLink: {
    method: 'post',
    path: '/{organisationSubprocessorId}/suppliers/{supplierSubprocessorId}/delete',
  },
  // sources
  listSubprocessorSources: { method: 'post', path: '/sources' },
  createSubprocessorSource: { method: 'post', path: '/sources/create' },
  updateSubprocessorSource: { method: 'post', path: '/sources/{sourceId}/update' },
  deleteSubprocessorSource: { method: 'post', path: '/sources/{sourceId}/delete' },
  // extraction jobs
  createSubprocessorExtractionJob: { method: 'post', path: '/sources/{sourceId}/extract' },
  getExtractionJob: { method: 'get', path: '/sources/{sourceId}/extraction-job/{jobId}' },
  getLatestExtractionJob: { method: 'get', path: '/sources/{sourceId}/extraction-job/latest' },
} as const
